import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { Observable } from 'rxjs';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CompanyCollectorMerchantRepository } from '@domain/company-collector-merchant/repositories/company-collector-merchant.repository';
import { ListCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/list-company-collector-merchant.dto-request';
import { GetCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/get-company-collector-merchant.dto-request';
import { CreateCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/create-company-collector-merchant-request.dto';
import { UpdateCompanyCollectorMerchantRequestDto } from '@domain/company-collector-merchant/dtos/update-company-collector-merchant-request.dto';
import { CompanyCollectorMerchantService } from '@core/services/entities/company-collector-merchant.service';
import { CompanyCollectorMerchantResponseDto } from '@domain/company-collector-merchant/dtos/company-collector-merchant-response.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorMerchantRepositoryService
  implements CompanyCollectorMerchantRepository
{
  constructor(
    private CompanyCollectorMerchantService: CompanyCollectorMerchantService,
  ) {}

  list(
    request: ListCompanyCollectorMerchantRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<CompanyCollectorMerchantResponseDto>>
  > {
    return this.CompanyCollectorMerchantService.list(request);
  }

  get(
    request: GetCompanyCollectorMerchantRequestDto,
  ): Observable<ApiResponse<CompanyCollectorMerchantResponseDto[]>> {
    return this.CompanyCollectorMerchantService.get(request);
  }

  create(
    request: CreateCompanyCollectorMerchantRequestDto,
  ): Observable<ApiResponse<CompanyCollectorMerchantResponseDto>> {
    return this.CompanyCollectorMerchantService.create(request);
  }

  update(
    request: UpdateCompanyCollectorMerchantRequestDto,
  ): Observable<ApiResponse<CompanyCollectorMerchantResponseDto>> {
    return this.CompanyCollectorMerchantService.update(request);
  }

  delete(
    request: RefId,
  ): Observable<ApiResponse<CompanyCollectorMerchantResponseDto>> {
    return this.CompanyCollectorMerchantService.delete(request);
  }
}
